export default {
  // 页面标题
  titles: {
    campaignList: '营销计划列表',
  },
  
  // 按钮
  buttons: {
    createCampaign: '新建营销计划',
  },
  
  // 状态
  status: {
    creating: '创建中…',
    loading: '加载中…',
  },
  
  // 消息
  messages: {
    deleteSuccess: '计划删除成功',
    deleteFailed: '计划删除失败，请稍后重试',
    bindOrgSuccess: '组织绑定成功',
    bindOrgFailed: '组织绑定失败，请稍后重试',
  },
  
  // 错误消息
  errors: {
    getCampaignListFailed: '获取计划列表失败',
    createCampaignFailed: '创建活动失败，请稍后重试',
  },

  // 空状态
  empty: {
    noCampaigns: '您还没有创建任何营销计划。现在就创建一个营销计划，开始拿到结果吧！',
  },
};
